import { render, staticRenderFns } from "./Avaliacao_v3.vue?vue&type=template&id=5aa65298&scoped=true"
import script from "./Avaliacao_v3.vue?vue&type=script&lang=js"
export * from "./Avaliacao_v3.vue?vue&type=script&lang=js"
import style0 from "./Avaliacao_v3.vue?vue&type=style&index=0&id=5aa65298&prod&scoped=true&lang=css"
import style1 from "./Avaliacao_v3.vue?vue&type=style&index=1&id=5aa65298&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa65298",
  null
  
)

export default component.exports